import { render, staticRenderFns } from "./SearchSave.vue?vue&type=template&id=4bbea4b4&scoped=true&"
import script from "./SearchSave.vue?vue&type=script&lang=js&"
export * from "./SearchSave.vue?vue&type=script&lang=js&"
import style0 from "./SearchSave.vue?vue&type=style&index=0&id=4bbea4b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbea4b4",
  null
  
)

export default component.exports